import { render } from "./tplCommittee.vue?vue&type=template&id=219589da&scoped=true"
import script from "./tplCommittee.vue?vue&type=script&lang=js"
export * from "./tplCommittee.vue?vue&type=script&lang=js"

import "./tplCommittee.vue?vue&type=style&index=0&id=219589da&scoped=true&lang=css"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219589da"]])

export default __exports__